import { UnifiedThemeOptions } from '@backstage/theme';
import { radius } from './tokens';

/**
 * Component overrides expressing the design system: sentence-case buttons with
 * an 8px radius and a soft shadow; cards at 12px with a hairline border + a
 * low-contrast shadow; pill chips; rounded inputs. Authored in MUI v5 form —
 * `createUnifiedTheme` bridges these to the MUI v4 components core-components use.
 *
 * The card border + shadow are passed in per mode: a light hairline / subtle
 * dark shadow reads as "too sharp" / "invisible" on the opposite surface.
 */
export const makeClrslateComponents = (opts: {
  border: string;
  shadows: { xs: string; sm: string };
}): UnifiedThemeOptions['components'] => ({
  MuiButton: {
    styleOverrides: {
      root: { textTransform: 'none', borderRadius: radius.md, fontWeight: 600 },
      contained: { boxShadow: opts.shadows.xs },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: { borderRadius: radius.xl },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: radius.xl,
        border: `1px solid ${opts.border}`,
        boxShadow: opts.shadows.sm,
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: radius.full, fontWeight: 600 },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: { borderRadius: radius.md },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 500 },
    },
  },
});
